import { render } from "./TableB.vue?vue&type=template&id=3de84798&scoped=true"
import script from "./TableB.vue?vue&type=script&lang=ts"
export * from "./TableB.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-3de84798"

export default script